// extracted by mini-css-extract-plugin
module.exports = {"alignSelfCenter":"TradeRow_alignSelfCenter_38Mb9","mrXs":"TradeRow_mrXs_1Auph","mAuto":"TradeRow_mAuto_1-k-U"};